import AdditionalPaymentInfo from './AdditionalPaymentInfo';

export default AdditionalPaymentInfo;
